import { MealKey } from '../types/mealPlan';

export interface TrainingMealSchedule {
  times: Record<MealKey, string>;
  preWorkoutMeal: MealKey;
  postWorkoutMeal: MealKey | null;
  preWorkoutTime: string;
  postWorkoutTime: string;
}

const MEAL_ORDER: MealKey[] = ['breakfast', 'morningSnack', 'lunch', 'afternoonSnack', 'dinner', 'eveningSnack'];
const DEFAULT_TIMES = [420, 600, 780, 960, 1140, 1290];
const MIN_MEAL_GAP = 150;

const toMinutes = (time: string): number | null => {
  const match = /^(\d{2}):(\d{2})$/.exec(time);
  if (!match) return null;
  const hours = Number(match[1]);
  const minutes = Number(match[2]);
  return hours < 24 && minutes < 60 ? hours * 60 + minutes : null;
};

const toTime = (minutes: number): string => {
  const normalized = ((minutes % 1440) + 1440) % 1440;
  return `${String(Math.floor(normalized / 60)).padStart(2, '0')}:${String(normalized % 60).padStart(2, '0')}`;
};

/** Gera uma rotina inicial de refeições em torno do treino; horários podem ser ajustados pelo nutricionista. */
export function getTrainingMealSchedule(trainingTime: string): TrainingMealSchedule | null {
  const workoutMinutes = toMinutes(trainingTime);
  if (workoutMinutes == null) return null;

  const preWorkoutMealIndex = workoutMinutes < 10 * 60 ? 0
    : workoutMinutes < 13 * 60 ? 1
      : workoutMinutes < 16 * 60 ? 2
        : workoutMinutes < 19 * 60 ? 3
          : workoutMinutes < 21 * 60 + 45 ? 4 : 5;
  const postWorkoutMealIndex = preWorkoutMealIndex < MEAL_ORDER.length - 1 ? preWorkoutMealIndex + 1 : null;
  const preWorkoutMinutes = workoutMinutes - 90;
  const postWorkoutMinutes = workoutMinutes + 60;
  const schedule = [...DEFAULT_TIMES];

  schedule[preWorkoutMealIndex] = preWorkoutMinutes;
  if (postWorkoutMealIndex !== null) schedule[postWorkoutMealIndex] = postWorkoutMinutes;

  for (let index = preWorkoutMealIndex - 1; index >= 0; index -= 1) {
    schedule[index] = Math.min(DEFAULT_TIMES[index], schedule[index + 1] - MIN_MEAL_GAP);
  }
  if (postWorkoutMealIndex !== null) {
    for (let index = postWorkoutMealIndex + 1; index < schedule.length; index += 1) {
      schedule[index] = Math.max(DEFAULT_TIMES[index], schedule[index - 1] + MIN_MEAL_GAP);
    }
  }

  return {
    times: Object.fromEntries(MEAL_ORDER.map((meal, index) => [meal, toTime(schedule[index])])) as Record<MealKey, string>,
    preWorkoutMeal: MEAL_ORDER[preWorkoutMealIndex],
    postWorkoutMeal: postWorkoutMealIndex === null ? null : MEAL_ORDER[postWorkoutMealIndex],
    preWorkoutTime: toTime(preWorkoutMinutes),
    postWorkoutTime: toTime(postWorkoutMinutes),
  };
}
